import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { ButtonProps } from '@/components/ui/button/button.types';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { SearchType } from '@/types/most-search-type';

interface CtaProcedureMedprevOnlineScheduleButtonProps extends ButtonProps {
  procedureType?: 'exam' | 'specialty';
  procedureName?: string;
  city: string;
  state: string;
  originCta?: string;
  searchType: SearchType;
}

export function CtaProcedureMedprevOnlineScheduleButton({
  procedureName,
  city,
  state,
  originCta,
  searchType,
}: CtaProcedureMedprevOnlineScheduleButtonProps) {
  const properties
    = searchType == SearchType.LABORATORIAL_EXAM
      ? { exame_nome: procedureName }
      : { especialidade_nome: procedureName };

  return (
    <Button
      data-testid={DataTestIdEnum.SEO_CTA_SCHEDULE_BY_WEB_BUTTON}
      startIcon={faCalendarCheck}
      className="h-12"
      data-analytics-event={
        searchType === SearchType.LABORATORIAL_EXAM
          ? AnalyticsEnum.CLICK_CTA_SCHEDULE_EXAM_BY_WEB_BUTTON
          : AnalyticsEnum.CLICK_CTA_SCHEDULE_SPECIALTY_BY_WEBSITE
      }
      data-analytics-properties={JSON.stringify({
        secao_origem: originCta,
        cidade: city,
        estado: state,
        ...properties,
      })}
      onClick={() => handleOpenSearchModal({ searchTerm: procedureName })}
    >
      Agendar pelo site
    </Button>
  );
}
